import { Injectable } from "@angular/core";
import { RestApi } from '../../auth/rest.api';
import { ISyncDataObject } from "app/core/typings/ISyncDataObject";

@Injectable({
  providedIn: 'root'
})
export class SyncFilesService implements ISyncFileService {

  constructor(private _authHttp: RestApi) { }

  getImportHistory(): Promise<any> {
    const url = 'api/syncfiles/import/history';
    return this._authHttp.get(url).toPromise()
      .then(response => response as string)
      .catch(this.handleError);
  }

  getExportHistory(): Promise<any> {
    const url = 'api/syncfiles/export/history';
    return this._authHttp.get(url).toPromise()
      .then(response => response as string)
      .catch(this.handleError);
  }

  executeImport(fileToImport: File): Promise<any> {
    const url = 'api/syncfiles/import/execute-import';
    const formData: FormData = new FormData();
    formData.append('file', fileToImport);

    return this._authHttp.postFile(url, formData)
      .toPromise()
      .then(response => {
        const httpResponse = response as ISyncDataObject;
        return Promise.resolve(httpResponse);
      }).catch(this.handleError);
  }

  downloadFileExport(fileName: string): Promise<any> {
    const url = 'api/syncfiles/export/download-file';
    const rawJson = `{ "fileName":"` + fileName + `" }`;
    return this._authHttp.post(url, JSON.parse(rawJson), { responseType: 'arraybuffer' })
      .toPromise()
      .then(response => Promise.resolve(response))
      .catch(this.handleError);
  }

  downloadFileImport(fileName: string): Promise<any> {
    const url = 'api/syncfiles/import/download-file';
    const rawJson = `{ "fileName":"` + fileName + `" }`;
    return this._authHttp.post(url, JSON.parse(rawJson), { responseType: 'arraybuffer' })
      .toPromise()
      .then(response => Promise.resolve(response))
      .catch(this.handleError);
  }

  exportFiles(selectedEntities: any): Promise<any> {
    const url = 'api/syncfiles/export/generate-export';
    return this._authHttp.post(url, selectedEntities).toPromise()
      .then(response => response as string)
      .catch(this.handleError);
  }

  getAttributes(): Promise<any> {
    const url = 'api/syncfiles/export/get-export-attributes';
    return this._authHttp.get(url).toPromise()
      .then(response => response as string)
      .catch(this.handleError);
  }


  private handleError(error: any): Promise<any> {
    let messageKey: string;

    switch (error.status) {
      case 415:
        messageKey = 'GLOBAL.INVALID_FILE';
        break;
      default:
        messageKey = 'GLOBAL.AN_ERROR_HAS_OCCURRED'
        break;

    }
    return Promise.reject(messageKey);
  }

}
